export default __webpack_public_path__ + "static/media/logo.ab0f8856.png";